import app from '@/main'

async function userGet (data) {
  return await app.wsp.sendRequest({
    data: data,
    method: 'user.get'
  })
}

export default userGet